(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["instagram-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const SECTION_ID = 'ig-carousel-{{ section.id }}';
  const cssEscape = (window.CSS && CSS.escape) ? CSS.escape : (s) => (s || '').replace(/([ !"#$%&'()*+,.\/:;<=>?@\[\\\]^`{|}~])/g, '\\$1');

  function whenImagesReady(root) {
    // Wait until images inside root have size; decode() if possible
    const imgs = Array.from(root.querySelectorAll('img'));
    if (!imgs.length) return Promise.resolve();
    return Promise.allSettled(imgs.map(img => {
      if (img.complete && img.naturalWidth) return Promise.resolve();
      if (img.decode) return img.decode().catch(() => {});
      return new Promise(res => img.addEventListener('load', res, { once: true }));
    })).then(() => {});
  }

  function init(root) {
    if (!root || root.__igBound) return;
    root.__igBound = true;

    const mask = root.querySelector('.ig__mask');
    const belt = root.querySelector('.ig__belt');
    const lane = root.querySelector('.ig__lane');
    if (!mask || !belt || !lane) return;

    const enabled = String(mask.dataset.enabled).toLowerCase() === 'true';
    const speed = Math.max(1, parseInt(mask.dataset.speed || '80', 10)); // px/sec
    const respectMotion = String(mask.dataset.respectMotion || 'false').toLowerCase() === 'true';
    const prefersReduced = respectMotion && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!enabled || prefersReduced) return;

    const start = () => {
      // Ensure lane is wider than mask; if not, clone cards until it is
      const ensureWidth = () => {
        const getWidth = el => el.getBoundingClientRect().width;
        let safety = 0;
        while (getWidth(lane) <= getWidth(mask) && safety < 20) {
          const children = Array.from(lane.children);
          if (!children.length) break;
          for (const n of children) {
            const clone = n.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            lane.appendChild(clone);
          }
          safety++;
        }
      };

      ensureWidth();

      // Build seamless pair (lane + clone)
      const twin = lane.cloneNode(true);
      twin.setAttribute('aria-hidden', 'true');
      belt.innerHTML = '';
      belt.appendChild(lane);
      belt.appendChild(twin);

      const measureLane = () => lane.getBoundingClientRect().width || 1;
      let laneW = measureLane();
      let x = 0;
      let paused = false;
      let rafId = null;
      let lastTs = 0;
      const pxPerMs = speed / 1000;

      // Pause/resume
      const pause = () => { paused = true; };
      const resume = () => { paused = false; };
      root.addEventListener('mouseenter', pause);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', pause);
      root.addEventListener('focusout', resume);
      document.addEventListener('visibilitychange', () => { paused = document.hidden; });

      // Resize observer: update laneW on layout change
      const ro = new ResizeObserver(() => { laneW = measureLane(); });
      ro.observe(lane);
      ro.observe(mask);

      // rAF loop
      const step = (ts) => {
        if (!lastTs) lastTs = ts;
        const dt = Math.min(40, ts - lastTs);
        lastTs = ts;

        if (!paused) {
          x -= dt * pxPerMs;
          if (-x >= laneW) x += laneW; // wrap after one full lane
          belt.style.transform = `translateX(${x}px)`;
        }
        rafId = requestAnimationFrame(step);
      };
      rafId = requestAnimationFrame(step);

      // cleanup
      const destroy = () => {
        cancelAnimationFrame(rafId);
        ro.disconnect();
        root.removeEventListener('mouseenter', pause);
        root.removeEventListener('mouseleave', resume);
        root.removeEventListener('focusin', pause);
        root.removeEventListener('focusout', resume);
        root.__igBound = false;
      };
      root.__igDestroy = destroy;
    };

    // Wait for measurable content, then start
    whenImagesReady(root).then(start);
  }

  // normal load
  init(document.getElementById(SECTION_ID));

  // DOM ready fallback
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document.getElementById(SECTION_ID)));
  }

  // Theme Editor lifecycle
  document.addEventListener('shopify:section:load', (e) => {
    const el = e.target && e.target.querySelector && e.target.querySelector('#' + cssEscape(SECTION_ID));
    if (el) init(el);
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const el = e.target && e.target.querySelector && e.target.querySelector('#' + cssEscape(SECTION_ID));
    if (el && el.__igDestroy) el.__igDestroy();
  });
  document.addEventListener('shopify:section:select', (e) => {
    const el = e.target && e.target.querySelector && e.target.querySelector('#' + cssEscape(SECTION_ID));
    if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
